import { useTranslation } from "react-i18next";
import { Spinner } from "@/components/ui/modal";

interface GoogleLoginButtonProps {
  loading: boolean;
  googleAuth: () => void;
}

export function GoogleLoginButton({ googleAuth, loading }: GoogleLoginButtonProps) {
  const { t } = useTranslation();
  return (
    <button
      className="w-full flex items-center justify-center gap-3 bg-white border border-gray-300 rounded-lg py-3 mb-4 hover:bg-gray-50 transition-colors"
      onClick={googleAuth}
    >
      {loading ? (
        <Spinner className="w-5 h-5" />
      ) : (
        <div className="flex items-center justify-center gap-3">
          <svg className="w-5 h-5" viewBox="0 0 48 48">
            <g>
              <path
                fill="#4285F4"
                d="M24 9.5c3.54 0 6.7 1.22 9.19 3.23l6.85-6.85C36.13 2.36 30.45 0 24 0 14.82 0 6.73 5.48 2.69 13.44l7.98 6.2C12.13 13.09 17.62 9.5 24 9.5z"
              />
              <path
                fill="#34A853"
                d="M46.1 24.55c0-1.64-.15-3.22-.42-4.74H24v9.01h12.42c-.54 2.9-2.18 5.36-4.66 7.01l7.2 5.6C43.98 37.13 46.1 31.36 46.1 24.55z"
              />
              <path
                fill="#FBBC05"
                d="M10.67 28.09c-1.13-3.36-1.13-6.97 0-10.33l-7.98-6.2C.99 15.36 0 19.55 0 24s.99 8.64 2.69 12.44l7.98-6.2z"
              />
              <path
                fill="#EA4335"
                d="M24 48c6.45 0 12.13-2.13 16.19-5.81l-7.2-5.6c-2.01 1.35-4.59 2.16-8.99 2.16-6.38 0-11.87-3.59-14.33-8.74l-7.98 6.2C6.73 42.52 14.82 48 24 48z"
              />
            </g>
          </svg>
          <span className="text-base font-medium text-gray-700">{t("login.google_login_button.continue_with_google")}</span>
        </div>
      )}
    </button>
  );
}
